const config = {
  api: {
    auth: process.env.REACT_APP_AUTH_URL || 'http://localhost:8000',
    research: process.env.REACT_APP_RESEARCH_URL || 'http://localhost:8001',
    reports: process.env.REACT_APP_REPORTS_URL || 'http://localhost:8002',
    billing: process.env.REACT_APP_BILLING_URL || 'http://localhost:8003',
    roster: process.env.REACT_APP_ROSTER_URL || 'http://localhost:8004',
    tamarac: process.env.REACT_APP_TAMARAC_URL || 'http://localhost:8005'
  },
  environment: process.env.REACT_APP_ENVIRONMENT || 'local',
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || ''
};

export default config;
